<script lang="ts">
  import type { User } from "firebase/auth";
  import { onDestroy } from "svelte";
  import { location,push } from "svelte-spa-router";
  import {
  Container,Dropdown,DropdownItem,DropdownMenu,DropdownToggle,Nav,Navbar,
  NavbarBrand,NavItem,
  NavLink
  } from "sveltestrap";
  import { appName,auth } from "../stores";
  import ArrowButton from "./landing/ArrowButton.svelte";

  let user: User | null;

  const userSubscription = auth.subscribe((u) => {
    user = u as User;
  });

  onDestroy(userSubscription);

  async function signIn() {
    await auth.signIn();
    await push("/app");
  }

  async function onSignOut() {
    await auth.signOut();
    await push("/");
  }
</script>

<Container>
  <Navbar expand="md">
    <NavbarBrand href="/" class="d-flex align-items-center">
      <img
        alt="logo"
        src="/images/logo.png"
        class="d-inline-block align-top"
        width="56"
        height="56"
      />&nbsp;&nbsp;&nbsp;
      <span class="title black-font">{$appName}</span>
    </NavbarBrand>
    <Nav class="ms-auto" navbar>
      {#if user}
        {#if $location !== "/app"}
          <NavItem>
            <NavLink href="/#/app">Dashboard</NavLink>
          </NavItem>
        {/if}
        <Dropdown nav inNavbar>
          <DropdownToggle nav caret
            >Signed in as: {user.displayName}</DropdownToggle
          >
          <DropdownMenu end>
            <DropdownItem on:click={onSignOut}>Sign out</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      {:else}
        <NavItem>
          <div class="black-font">
            <ArrowButton
              text="Sign in"
              green={false}
              onClick={signIn}
              href="/"
            />
          </div>
          <!-- <NavLink on:click={signIn}>Sign in →</NavLink>  -->
        </NavItem>
      {/if}
    </Nav>
  </Navbar>
</Container>

<style>
  .title {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    text-align: right;
  }

  .black-font {
    color: #2f2e34;
  }
</style>
